module.exports = __webpack_public_path__ + "img/pcomm.e88a2134.jpg";